import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, FormattedRelative } from 'react-intl';
import { Site } from 'four-nets/site';

export interface Props {
    value: Date;
}

class FormattedDateAgoView extends React.Component<Props> {
    static contextTypes = {
        intl: intlShape,
        site: PropTypes.instanceOf(Site),
    };

    render() {
        return (
            <FormattedRelative {...this.props} style='numeric'>
                {(text: string) => {
                    const { intl, site } = this.context;
                    const now = intl.now();
                    const { value } = this.props;

                    const days = (now - value.getTime()) / 1000 / 60 / 60 / 24;

                    if (days < 0.95) {
                        // FIXME: Upgrade react-intl to >3.0.0 version and rework time formatting
                        let bustledText = text;
                        try {
                            const parts = text.split(' ');
                            bustledText = `${parts[1]} ${parts[2] && parts[2].slice(0, 3)}`;
                        } catch {
                            // pass
                        }
                        return bustledText;
                    } else if (days < 2) {
                        return site.isSlovak ? '1 deň' : '1 den';
                    } else if (days >= 2) {
                        // FormattedDate ignores month='short' with days and year set and uses numeric for month too..
                        // return <FormattedDate value={value} month='short' year='numeric' />;
                        const formatted = `${intl.formatDate(value, { day: 'numeric' })} ${intl.formatDate(value, {
                            month: 'short',
                        })} ${intl.formatDate(value, { year: 'numeric' })}`;
                        return formatted;
                    }

                    return text;
                }}
            </FormattedRelative>
        );
    }
}

export default FormattedDateAgoView;
